import React from 'react'

const COLORS = ['#F57C00', '#E65100', '#FB8C00', '#FF9800', '#FFA726', '#FFB74D']

function getColor(name: string): string {
  let hash = 0
  for (let i = 0; i < name.length; i++) {
    hash = name.charCodeAt(i) + ((hash << 5) - hash)
  }
  return COLORS[Math.abs(hash) % COLORS.length]
}

function getInitials(name: string): string {
  return name
    .split(' ')
    .slice(0, 2)
    .map((w) => w[0])
    .join('')
    .toUpperCase()
}

interface AvatarProps {
  name: string
  size?: number
  className?: string
}

export const Avatar: React.FC<AvatarProps> = ({ name, size = 36, className }) => {
  const bg = getColor(name)
  const initials = getInitials(name)
  const fontSize = Math.round(size * 0.38)

  return (
    <div
      className={`flex items-center justify-center rounded-full flex-shrink-0 ${className || ''}`}
      style={{
        width: size,
        height: size,
        backgroundColor: bg,
        color: 'white',
        fontSize,
        fontWeight: 600,
      }}
    >
      {initials}
    </div>
  )
}
